/** This file is auto generated by convertSvgToJsx.ts */

import type { IconSVGProps } from '../../components/icon/Icon'
const sort_medium = (props?: IconSVGProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      stroke="#000"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={1.5}
      d="M6.077 3v16.673M2.154 15.75l3.923 3.923L10 15.75M17.846 20V3.327M21.77 7.25l-3.923-3.923-3.923 3.923"
    />
  </svg>
)
export default sort_medium
